import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { searchDocuments } from '../actions/document';

const getItems = payload => payload.items.map(doc => doc.id);

export default handleAction(searchDocuments, {
  next(state, { payload, meta: { query, page } }) {
    const itemsByPage = state[query]
      ? { ...state[query].itemsByPage, [page]: getItems(payload) }
      : { [page]: getItems(payload) };

    return {
      ...state,
      [query]: {
        total: payload.total,
        limit: payload.limit,
        itemsByPage
      }
    };
  },
  throw(state, { payload: { response }, meta: { query, page } }) {
    const target = state[query] || {};
    return {
      ...state,
      [query]: {
        ...target,
        itemsByPage: {
          ...(target.itemsByPage || {}),
          [page]: { error: true, message: response ? response.data : null }
        }
      }
    };
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/search-results.js